import { useEffect } from 'react';
import { useApiDelete } from '../../api/Api.hooks';
import { User } from '../../models/User';

export function useDeleteUserWithNoPassword(id: number | undefined) {
  const { data, isLoading, error, del } = useApiDelete<User>(`users/${id}`);
  useEffect(
    () => void (error && console.log('Del Current User Error', error)),
    [error]
  );
  return {
    deletedUser: data,
    deletingUser: isLoading,
    deleteUserError: error,
    deleteUser: del
  };
}
